import React from "react";

// styled components
import styled from "styled-components";

//react loader spinnner
import { ThreeDots } from "react-loader-spinner";

const Loading = (width, color) => {
  return (
    <LoadingStyle>
      <ThreeDots color={color ? color : "#0D6EFD"} />
    </LoadingStyle>
  );
};

const LoadingStyle = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export default Loading;
